import { DatePipe } from '@angular/common'
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core'
import { FormsModule } from '@angular/forms'

import {
    BaseComponent,
    SubcontractorTrainingDashboardMetrics,
    SubcontractorTrainingModule,
    SubcontractorTrainingOverdueRow,
} from '../../shared'

@Component({
    selector: 'app-subcontractor-training-dashboard',
    templateUrl: './subcontractor-training-dashboard.component.html',
    standalone: true,
    imports: [DatePipe, FormsModule],
})
export class SubcontractorTrainingDashboardComponent extends BaseComponent implements OnInit {
    @Input() availableModules: SubcontractorTrainingModule[] = []
    @Output() viewInviteDetails = new EventEmitter<string>()
    @Output() ready = new EventEmitter<void>()

    selectedModuleId = ''
    metrics = new SubcontractorTrainingDashboardMetrics()
    loadError = false

    ngOnInit() {
        this.refresh()
    }

    refresh() {
        const moduleId = this.selectedModuleId?.trim()
        const url = moduleId
            ? `/api/SubcontractorTrainingInvite/GetDashboardMetrics?moduleId=${encodeURIComponent(moduleId)}`
            : '/api/SubcontractorTrainingInvite/GetDashboardMetrics'

        this.cancelableRequest(
            'subconDashboard',
            true,
            this.services.data
                .get<SubcontractorTrainingDashboardMetrics>(
                    url,
                    undefined,
                    SubcontractorTrainingDashboardMetrics,
                )
                .subscribe({
                    next: metrics => {
                        this.loadError = false
                        this.metrics = metrics
                        this.ready.emit()
                    },
                    error: () => {
                        this.loadError = true
                        this.metrics = new SubcontractorTrainingDashboardMetrics()
                        this.ready.emit()
                    },
                }),
        )
    }

    onModuleFilterChange() {
        this.refresh()
    }

    get showModuleBreakdown() {
        return !this.selectedModuleId
    }

    get overdueCount() {
        return this.metrics.kpi.overdue
    }

    getDaysOverdue(row: SubcontractorTrainingOverdueRow) {
        return Math.max(0, row.daysSinceInvited - 7)
    }

    onViewDetails(row: SubcontractorTrainingOverdueRow) {
        this.viewInviteDetails.emit(row.inviteId)
    }
}
